export const getInfantsNames = (infants) => infants.length > 1
    ? infants.map((infant) => infant.givenName).join(", ")
    : infants[0].givenName && infants[0].givenName.length > 1
        ? infants[0].givenName
        : "Gyermeked";
